import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useVideoStatus, getApiBaseUrl } from '../queries';

const VideoPlayback: React.FC = () => {
  const { videoId } = useParams<{ videoId: string }>();
  const navigate = useNavigate();
  const { data: status, isLoading: isLoadingStatus, error: statusError } = useVideoStatus(videoId || '');

  if (!videoId) {
    return (
      <div className="error">
        Invalid video ID
      </div>
    );
  }

  if (statusError) {
    return (
      <div className="error">
        Error: {statusError.message}
      </div>
    );
  }

  if (isLoadingStatus) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
        Checking video status...
      </div>
    );
  }

  if (status && status.status === 'downloading') {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
        Downloading video... Please wait.
    </div>
    );
  }

  if (status && status.status === 'ready' && status.stream_url) {
    // Convert relative URLs to full URLs for local storage
    const videoSrc = status.storage_type === 'local' && status.stream_url.startsWith('/')
      ? `${getApiBaseUrl()}${status.stream_url}`
      : status.stream_url;

    return (
      <div className="video-player">
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            ← Back to Home
          </button>
        </div>
        <video
          controls
          playsInline
          preload="metadata"  // TODO (evan): waht does this do?
          style={{ width: '100%', height: 'auto' }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div style={{ textAlign: 'center', marginTop: '20px', color: '#666' }}>
          Video ID: {videoId} ({status.storage_type})
        </div>
      </div>
    );
  }

  return (
    <div className="error">
      Video not found or not ready
    </div>
  );
};

export default VideoPlayback;
